import React from "react";
import { Link } from "react-router-dom";
import { MdOutlineCode } from "react-icons/md";
import { MdOutlineCodeOff } from "react-icons/md";
import { FaFacebook } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { FaDiscord } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { AnimatePresence, motion } from "framer-motion";
import useTheme from "../../hooks/useTheme";

const linkBtnVariants = {
	tap: {
		scale: 1,
	},
	hover: {
		scale: 1.3,
	},
	transition: {
		duration: 0.5,
	},
};

const socialLinks = [
	{
		id: 1,
		title: "Facebook",
		icon: <FaFacebook />,
		url: "https://www.facebook.com/ivanvielled",
		color: "#1877F2",
	},
	{
		id: 2,
		title: "LinkedIn",
		icon: <FaLinkedin />,
		url: "https://www.linkedin.com/in/ivanvielle/",
		color: "#0077B5",
	},
	{
		id: 3,
		title: "Discord",
		icon: <FaDiscord />,
		url: "https://discord.com/users/alphachino5947",
		color: "#7289da",
	},
	{
		id: 4,
		title: "Instagram",
		icon: <FaInstagram />,
		url: "https://www.instagram.com/ivanvielle/",
		color: "#833AB4",
	},
];

const socialLinksRow = socialLinks.map((socialLink) => (
	<motion.button
		key={socialLink.id}
		variants={linkBtnVariants}
		whileHover="hover"
		whileTap="tap"
		transition="transition"
		style={{ color: `${socialLink.color}` }}
		className={`text-5xl`}>
		<Link
			to={socialLink.url}
			target="_blank">
			{socialLink.icon}
		</Link>
	</motion.button>
));

const SocialMediaSection = () => {
	return (
		<div className="flex flex-col px-10 py-2">
			<h1 className="text-3xl mb-5 lg:mb-2">
				<span className="text-green-800 hover:text-green-600 cursor-pointer">
					Connect
				</span>{" "}
				with me
			</h1>
			<div className="flex justify-center items center gap-5">
				{socialLinksRow}
			</div>
		</div>
	);
};

export default SocialMediaSection;
